import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n\t\t\tquery query {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t  description\n\t\t\t\t\t\t  tags\n\t\t\t\t\t\t  priceRange {\n\t\t\t\t\t\t  \tminVariantPrice {\n\t\t\t\t\t\t  \t\tcurrencyCode\n\t\t\t\t\t\t  \t\tamount\n\t\t\t\t\t\t  \t}\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  options {\n\t\t\t\t\t\t    id\n\t\t\t\t\t\t    name\n\t\t\t\t\t\t    values\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  variants(first:100) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        id \n\t\t\t\t\t\t        title\n\t\t\t\t\t\t        priceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t          currencyCode\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        compareAtPriceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t          currencyCode\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        availableForSale\n\t\t\t\t\t\t        selectedOptions {\n\t\t\t\t\t\t          name\n\t\t\t\t\t\t          value\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        image {\n\t\t\t\t\t\t          altText\n\t\t\t\t\t\t          thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t          productImg: transformedSrc(maxWidth:800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:50) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 485, crop: CENTER)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t        squareImg:transformedSrc(maxWidth:600, maxHeight:600, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t'], ['\n\t\t\tquery query {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t  description\n\t\t\t\t\t\t  tags\n\t\t\t\t\t\t  priceRange {\n\t\t\t\t\t\t  \tminVariantPrice {\n\t\t\t\t\t\t  \t\tcurrencyCode\n\t\t\t\t\t\t  \t\tamount\n\t\t\t\t\t\t  \t}\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  options {\n\t\t\t\t\t\t    id\n\t\t\t\t\t\t    name\n\t\t\t\t\t\t    values\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  variants(first:100) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        id \n\t\t\t\t\t\t        title\n\t\t\t\t\t\t        priceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t          currencyCode\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        compareAtPriceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t          currencyCode\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        availableForSale\n\t\t\t\t\t\t        selectedOptions {\n\t\t\t\t\t\t          name\n\t\t\t\t\t\t          value\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        image {\n\t\t\t\t\t\t          altText\n\t\t\t\t\t\t          thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t          productImg: transformedSrc(maxWidth:800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:50) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 485, crop: CENTER)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t        squareImg:transformedSrc(maxWidth:600, maxHeight:600, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t']);

import React, { Component } from 'react';
import { Query, compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';

// display components
import Kit from '../kit/kit';
import Product from './product';
import Showcase from './showcase';

import { createProductQuery } from '../queries';

import './product.css';

var _ref2 = React.createElement(
	'div',
	null,
	'Loading...'
);

var ProductQuery = function (_Component) {
	_inherits(ProductQuery, _Component);

	function ProductQuery() {
		_classCallCheck(this, ProductQuery);

		return _possibleConstructorReturn(this, (ProductQuery.__proto__ || Object.getPrototypeOf(ProductQuery)).apply(this, arguments));
	}

	_createClass(ProductQuery, [{
		key: 'createProductQuery',
		value: function createProductQuery(handle) {
			return gql(_templateObject, handle);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return React.createElement(
				Query,
				{ query: this.createProductQuery(this.props.match.params.handle) },
				function (_ref) {
					var loading = _ref.loading,
					    err = _ref.err,
					    data = _ref.data;

					if (!loading) {
						var product = data.productByHandle;
						var is_kit = product.description.indexOf('[[KITBUILDER]]') >= 0;
						var is_showcase = product.description.indexOf('[[SHOWCASE]]') >= 0;
						var is_product = product.description.indexOf('[[PRODUCTDETAILS]]') >= 0;
						return React.createElement(
							'div',
							{ className: 'simple-product' },
							is_kit && React.createElement(Kit, {
								product: product
							}),
							is_showcase && React.createElement(Showcase, {
								parentProduct: product
							}),
							is_product && React.createElement(Product, {
								product: product,
								handle: _this2.props.match.params.handle
							})
						);
					} else {
						return _ref2;
					}
				}
			);
		}
	}]);

	return ProductQuery;
}(Component);

export default ProductQuery;